import {
  DialogDrawer,
  EmbeddedDrawer,
  EmbeddedDrawerProps,
} from "components/Drawer";
import { useAppSelector } from "hooks/useStore";
import RightSidebarPortal from "./RightSidebarPortal";

/**
 * A right sidebar drawer component that is embedded in the right sidebar portal on desktop and uses a dialog wrapper on mobile.
 */
export const RightSidebarDrawer = ({
  isOpen,
  onClose,
  children,
  size = "sm",
  isActive = true,
  ...props
}: EmbeddedDrawerProps & { isOpen: boolean; isActive?: boolean }) => {
  const is640WideScreen = useAppSelector(
    (state) => state.setting.is640WideScreen
  );

  // If not active, don't render anything
  if (!isActive) {
    return null;
  }

  return (
    <>
      {is640WideScreen ? (
        <DialogDrawer open={isOpen} onClose={onClose} size={size} {...props}>
          {children}
        </DialogDrawer>
      ) : (
        <RightSidebarPortal>
          <EmbeddedDrawer
            open={isOpen}
            onClose={onClose}
            size={size}
            {...props}
          >
            {children}
          </EmbeddedDrawer>
        </RightSidebarPortal>
      )}
    </>
  );
};
